import { render, staticRenderFns } from "./FabItem.vue?vue&type=template&id=5b0fff96&scoped=true"
import script from "./FabItem.vue?vue&type=script&lang=js"
export * from "./FabItem.vue?vue&type=script&lang=js"
import style0 from "./FabItem.vue?vue&type=style&index=0&id=5b0fff96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0fff96",
  null
  
)

export default component.exports